var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 1.59375C5.71484 1.59375 5.5 1.37891 5.5 1.07812C5.5 0.798828 5.71484 0.5625 6.01562 0.5625H9.10938C9.38867 0.5625 9.625 0.798828 9.625 1.07812V4.17188C9.625 4.47266 9.38867 4.6875 9.10938 4.6875C8.80859 4.6875 8.59375 4.47266 8.59375 4.17188V2.32422L4.29688 6.59961C4.10352 6.81445 3.78125 6.81445 3.58789 6.59961C3.37305 6.40625 3.37305 6.08398 3.58789 5.86914L7.86328 1.59375H6.01562ZM0 2.45312C0 1.80859 0.537109 1.25 1.20312 1.25H3.60938C3.88867 1.25 4.125 1.48633 4.125 1.76562C4.125 2.06641 3.88867 2.28125 3.60938 2.28125H1.20312C1.0957 2.28125 1.03125 2.36719 1.03125 2.45312V8.98438C1.03125 9.0918 1.0957 9.15625 1.20312 9.15625H7.73438C7.82031 9.15625 7.90625 9.0918 7.90625 8.98438V6.57812C7.90625 6.29883 8.12109 6.0625 8.42188 6.0625C8.70117 6.0625 8.9375 6.29883 8.9375 6.57812V8.98438C8.9375 9.65039 8.37891 10.1875 7.73438 10.1875H1.20312C0.537109 10.1875 0 9.65039 0 8.98438V2.45312Z",
    fill: "#015294"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.343d0f497eeec12b831da7d94e8bf260.svg";
export { ForwardRef as ReactComponent };